import * as React from "react";
import { useState } from "react";
import { styled } from "@mui/material";

import { UserLoginContainer } from "./userLoginContainer";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import { NewPasswordForm } from "./newPasswordForm";

//region [[ Styles ]]
const RosebudLoginContainer = styled(UserLoginContainer)({
  background: KahunColorMap.White,
  boxShadow: "#8082827d -1px 1px 7px 1px",
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface NewPasswordWidgetProps {
  onResetComplete: () => void;
  message?: string;
  hideLogo?: boolean;
}

//endregion [[ Props ]]
export const NewPasswordWidget = ({
  onResetComplete,
  ...props
}: NewPasswordWidgetProps) => {
  const [error, setError] = useState("");

  return (
    <RosebudLoginContainer
      error={error}
      message={props.message}
      hideLogo={props.hideLogo}
    >
      <NewPasswordForm
        onResetComplete={onResetComplete}
        onError={setError}
      />
    </RosebudLoginContainer>
  );
};
